module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_wheel.86cd2f5e.svg";